import {Pipe, PipeTransform} from '@angular/core';

import {MeasuresHelper} from '@selpia/measures/data-access';
import {Measure} from '@selpia/shared/models';

@Pipe({
  name: 'getMeasure',
  standalone: true,
})
export class GetMeasurePipe implements PipeTransform {
  transform(value: string | undefined, allMeasures: Measure[] | undefined): Measure | undefined {
    if(!value || !allMeasures) {
      return undefined;
    }

    try {
      return MeasuresHelper.getForCode(value, allMeasures);
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }
}
